import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { createFormData } from '../helpers/createFormdata';
import { getApiErrorMessage, toApiError } from '../utils';
import type { TestimonialDTO, TestimonialMutationPayload } from './types';

export const useCreateTestimonial = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (payload: TestimonialMutationPayload) => {
			try {
				const formData = payload instanceof FormData ? payload : createFormData(payload);
				const { data } = await api.post<TestimonialDTO>('/management/testimonial/create', formData);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar depoimento');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['testimonials'] });
		},
		onError: error => console.error('Erro ao criar depoimento:', getApiErrorMessage(error, 'Erro ao criar depoimento')),
	});
};
